import Header from '../components/Header';
import Hero from '../components/Hero';
import styled from 'styled-components';
import SEO from '../components/SEO';
const HomeWrap = styled.div`
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Home = ({ homeData }) => {
  return (
    <HomeWrap>
      <SEO
        title="Home"
        description="Ready-to-use website templates: landing pages, corporate sites, marketplaces."
        path="/home"
      />
      <Hero heroData={homeData?.hero} />
    </HomeWrap>
  );
};

export default Home;
